/**
 * Próbuje wyciągnąć nazwę pliku z nagłówka Content-Disposition.
 * Obsługuje: filename*=UTF-8''nazwa.csv oraz filename="nazwa.csv"
 * @param {string | undefined} header
 * @returns {string|null}
 */
export function parseFileNameFromContentDisposition(header) {
  if (!header) return null;
  header = header.trim();

  const filenameStar = /filename\*=([^']*)''([^;]+)/i.exec(header);
  if (filenameStar?.[2]) return decodeURIComponent(filenameStar[2]);

  const filename = /filename="?([^";]+)"?/i.exec(header);
  return filename?.[1] ?? null;
}

/**
 * Inicjuje pobranie Blob'a jako pliku na kliencie.
 * @param {Blob} blob
 * @param {string} fallbackName
 */
export function downloadBlob(blob, fallbackName) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;

  // iOS Safari nie wspiera a.download – otworzy nową kartę
  const canSetDownload = "download" in HTMLAnchorElement.prototype;
  if (canSetDownload) a.download = fallbackName;

  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
